<template>
  <div>
    <v-card class="sf-card"
            flat>
      <div class="sf-card__header">
        <div>
          <div class="sf-card__subtitle">{{ $t('personalDetails') }}</div>
          <h2 class="sf-card__title">{{ supplierName }}</h2>
        </div>
      </div>
      <v-card-text class="sf-card__body">
        <v-alert class="mb-6"
                 text
                 type="error"
                 v-bind:value="validationAlert">
          {{ $t('pleaseCompleteTheForm') }}
        </v-alert>
        <v-form ref="form">
          <v-row class="sf-form-row">
            <v-col cols="12">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('companyName')"
                            v-model="supplier.companyName" />
            </v-col>
          </v-row>

          <h3 class="sf-section-title mt-6">{{ $t('contact') }}</h3>

          <v-row class="sf-form-row">
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('givenName')"
                            v-bind:rules="[ rules.required ]"
                            v-model="supplier.givenName" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('familyName')"
                            v-bind:rules="[ rules.required ]"
                            v-model="supplier.familyName" />
            </v-col>
          </v-row>

          <h3 class="sf-section-title mt-6">{{ $t('address') }}</h3>

          <v-row class="sf-form-row">
            <v-col cols="12">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('streetAddress')"
                            v-bind:rules="[ rules.required ]"
                            v-model="supplier.streetAddress" />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('postalCode')"
                            v-bind:rules="[ rules.required ]"
                            v-model="supplier.postalCode" />
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field dense hide-details="auto"
                            outlined
                            v-bind:label="$t('city')"
                            v-bind:rules="[ rules.required ]"
                            v-model="supplier.city" />
            </v-col>
          </v-row>

          <h3 class="sf-section-title mt-6">{{ $t('contactDetails') }}</h3>

          <v-text-field dense hide-details="auto"
                        outlined
                        v-bind:label="$t('email')"
                        v-bind:rules="[ rules.required, rules.validEmailAddress ]"
                        v-model="supplier.email" />

          <h3 class="sf-section-title mt-6">{{ $t('registrationDetails') }}</h3>

          <v-row class="sf-form-row">
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            type="number"
                            outlined
                            v-bind:label="$t('countBoothStaff')"
                            v-bind:rules="[ rules.required ]"
                            v-model="supplier.countBoothStaff" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            type="number"
                            outlined
                            v-bind:label="$t('countTables')"
                            v-bind:rules="[ rules.required ]"
                            v-model="supplier.countTables" />
            </v-col>
          </v-row>

          <v-alert class="my-4"
                   dense
                   text
                   type="info">
            {{ $t('pleaseNoteThatAllEquipmentForTheDecorationOfTheBoothOrTheTablesMustBeBroughtByTheSupplier') }}
          </v-alert>

          <v-row class="sf-form-row">
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            type="number"
                            outlined
                            v-bind:label="$t('countRegularOutlets')"
                            v-bind:rules="[ rules.required ]"
                            v-model="supplier.countRegularOutlets" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            type="number"
                            outlined
                            v-bind:label="$t('countSpecialOutlets')"
                            v-bind:rules="[ rules.required ]"
                            v-model="supplier.countSpecialOutlets" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field dense hide-details="auto"
                            type="number"
                            outlined
                            v-bind:label="$t('countDinnerAttendees')"
                            v-bind:rules="[ rules.required ]"
                            v-model="supplier.countDinnerAttendees" />
            </v-col>
            <v-col cols="12">
              <v-textarea dense hide-details="auto"
                          outlined
                          v-bind:label="$t('comments')"
                          v-model="supplier.comments" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions v-if="nextStepButton != null || previousStepButton != null">
        <v-btn color="primary"
               outlined
               v-if="previousStepButton != null"
               v-on:click="previousStep">
          <v-icon left>ti-arrow-left</v-icon>
          {{ previousStepButton }}
        </v-btn>
        <v-spacer />
        <v-btn color="accent"
               depressed
               v-if="nextStepButton != null"
               v-on:click="nextStep">
          {{ nextStepButton }}
          <v-icon right>ti-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  export default {
    computed: {
      supplierName() {
        if (this.supplier.companyName != null && this.supplier.companyName.length !== 0) {
          return this.supplier.companyName
        }

        if (this.supplier.givenName != null && this.supplier.givenName.length !== 0 && this.supplier.familyName != null && this.supplier.familyName.length !== 0) {
          return `${this.supplier.givenName} ${this.supplier.familyName}`
        }

        return this.$t('unknown')
      },
      rules() {
        return {
          required: v => !!v || this.$t('form.required'),
          validEmailAddress: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('form.pleaseEnterAValidEmailAddress')
        }
      }
    },
    methods: {
      nextStep() {
        this.$emit('next-step')
      },
      previousStep() {
        this.$emit('previous-step')
      },
      validate() {
        return this.$refs.form.validate()
      }
    },
    name: 'SupplierPersonalDetailsCard',
    props: {
      supplier: Object,
      nextStepButton: String,
      previousStepButton: String,
      validationAlert: Boolean
    }
  }
</script>

<i18n>
  {
    "de": {
      "address": "Adresse",
      "city": "Stadt",
      "contact": "Ansprechpartner",
      "contactDetails": "Kontakt",
      "companyName": "Firmenname",
      "email": "E-Mail-Adresse",
      "givenName": "Vorname",
      "familyName": "Nachname",
      "pleaseCompleteTheForm": "Bitte vervollständigen Sie Ihre Angaben.",
      "postalCode": "Postleitzahl",
      "supplier": "Lieferant",
      "streetAddress": "Adresse",
      "unknown": "Unbekannt",
      "registrationDetails": "Anmeldeinformationen",
      "countBoothStaff": "Anzahl der Standmitarbeiter",
      "countTables": "Menge Biertischgarnituren",
      "countRegularOutlets": "Menge an Steckdosen Haushaltsstrom",
      "countSpecialOutlets": "Menge an Steckdosen Starkstrom",
      "countDinnerAttendees": "Teilnahme am gemeinsamen Abendessen/Personenanzahl",
      "comments": "Weitere Anmerkungen",
      "pleaseNoteThatAllEquipmentForTheDecorationOfTheBoothOrTheTablesMustBeBroughtByTheSupplier": "Bitte beachten Sie, dass sämtliches Equipment für die Dekoration des Messestandes bzw. der Biertische vom Aussteller selbst mitgebracht werden muss.",
      "personalDetails": "Persönliche Angaben"
    },
    "en": {
      "address": "Address",
      "city": "City",
      "contact": "Contact",
      "contactDetails": "Contact details",
      "companyName": "Company name",
      "email": "Email",
      "givenName": "Given name",
      "familyName": "Family name",
      "pleaseCompleteTheForm": "Please complete the form.",
      "postalCode": "Postal code",
      "supplier": "Supplier",
      "streetAddress": "Street address",
      "unknown": "Unknown",
      "registrationDetails": "Registration details",
      "countBoothStaff": "Count booth staff",
      "countTables": "Count tables",
      "countRegularOutlets": "Count regular outlets",
      "countSpecialOutlets": "Count special outlets",
      "countDinnerAttendees": "Count dinner attendees",
      "comments": "Comments",
      "pleaseNoteThatAllEquipmentForTheDecorationOfTheBoothOrTheTablesMustBeBroughtByTheSupplier": "Please note that all equipment for the decoration of the booth or the tables must be brought by the supplier.",
      "personalDetails": "Personal details"
    }
  }
</i18n>